import { api } from "../component/constent";

// List
export const getAllocationHeads = async () => {
  const response = await api.get("/entry/allocation-head");

  return response.data;
};


export const getDepartments = async () => {
  const { data } = await api.get("/entry/allocation-head/departments");
  return data;
};


// Report Types
export const getReportTypes = async () => {
  const response = await api.get( "/entry/allocation-head/report-types" );
  return response.data;
};


// Insert
export const insertAllocationHead = async (data) => {
  const response = await api.post("/entry/allocation-head",data);
  return response.data;
};


// Update
// Update Allocation Head
export const updateAllocationHead = async (AllocationHeadCode, data) => {
  const response = await api.put(`/entry/allocation-head/${AllocationHeadCode}`,  data );
  return response.data;
};

// Delete
export const deleteAllocationHead = async ( AllocationHeadCode) => {
  const response = await api.delete(`/entry/allocation-head/${AllocationHeadCode}`,
    );

  return response.data;
};